import { render, staticRenderFns } from "./HistogramSparkline.vue?vue&type=template&id=450d2880&scoped=true"
import script from "./HistogramSparkline.vue?vue&type=script&lang=js"
export * from "./HistogramSparkline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450d2880",
  null
  
)

export default component.exports